import React, { useEffect, useState } from 'react';
import { Button, Drawer, Layout, Menu, Spin, Typography } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { CashFlowProvider, useCashFlow } from '../common/CashFlowContext';
import OnboardingScreen from '../onboarding/OnboardingScreen';

const TABS = [
  { key: '/cash-flow', label: '홈' },
  { key: '/cash-flow/stats', label: '통계' },
  { key: '/cash-flow/budget', label: '예산' },
  { key: '/cash-flow/settings', label: '설정' },
];

function CashFlowShell() {
  const { currentUserId, users, usersLoading, currentUser } = useCashFlow();
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [drawerVisible, setDrawerVisible] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (usersLoading) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (currentUserId == null || !users.some((u) => u.id === currentUserId)) {
    return <OnboardingScreen />;
  }

  const selectedKey = (() => {
    const matched = TABS
      .map((t) => t.key)
      .filter((k) => location.pathname === k || location.pathname.startsWith(k + '/'))
      .sort((a, b) => b.length - a.length);
    return matched[0] || '/cash-flow';
  })();

  const closeDrawer = () => setDrawerVisible(false);

  return (
    <Layout style={{ minHeight: '100vh', backgroundColor: '#F8F8F8' }}>
      <Layout.Header style={{
        position: 'sticky', top: 0, zIndex: 10, width: '100%', padding: '0 24px',
        background: '#fff', borderBottom: '1px solid #f0f0f0', display: 'flex', alignItems: 'center',
      }}>
        {isMobile && (
          <Button
            type="text"
            icon={<MenuOutlined />}
            onClick={() => setDrawerVisible(true)}
            style={{ marginRight: 8 }}
          />
        )}
        <Typography.Title level={4} style={{ margin: 0, marginRight: 32, color: '#4A90D9', whiteSpace: 'nowrap' }}>
          가계부 · {currentUser?.name || ''}
        </Typography.Title>
        {!isMobile && (
          <Menu
            mode="horizontal"
            selectedKeys={[selectedKey]}
            style={{ flex: 1, borderBottom: 'none' }}
            items={TABS.map((t) => ({
              key: t.key,
              label: <NavLink to={t.key} end={t.key === '/cash-flow'}>{t.label}</NavLink>,
            }))}
          />
        )}
      </Layout.Header>

      {isMobile && (
        <Drawer
          title="메뉴"
          placement="left"
          onClose={closeDrawer}
          open={drawerVisible}
          styles={{ body: { padding: 0 } }}
        >
          <Menu
            mode="inline"
            selectedKeys={[selectedKey]}
            onClick={closeDrawer}
            items={TABS.map((t) => ({
              key: t.key,
              label: <NavLink to={t.key} end={t.key === '/cash-flow'}>{t.label}</NavLink>,
            }))}
          />
        </Drawer>
      )}

      <Layout.Content style={{ padding: 24 }}>
        <Outlet />
      </Layout.Content>
    </Layout>
  );
}

export default function CashFlowLayout() {
  return (
    <CashFlowProvider>
      <CashFlowShell />
    </CashFlowProvider>
  );
}
